import { Row, Text, Icon } from "@amzn/meridian";
import thumbsDownTokens from "@amzn/meridian-tokens/base/icon/thumbs-down";
import thumbsUpTokens from "@amzn/meridian-tokens/base/icon/thumbs-up";
import "./userFeedback.scss";

interface UserFeedbackProps {
  voteUp: boolean | null;
  downvoteReason: string | null;
}

const UserFeedback = (props: UserFeedbackProps) => (
  <Row
    alignmentHorizontal="end"
    alignmentVertical="center"
    spacingInset={"400 none none none"}
    spacing={"300"}
  >
    <Text color="secondary" className="chat-message__user-feedback">
      User Feedback:
    </Text>
    <Row
      type="outline"
      spacingInset={"300"}
      alignmentVertical="center"
      alignmentHorizontal="center"
    >
      {props.downvoteReason?.length && (
        <span className="chat-messages__feedback-text">
          {props.downvoteReason}
        </span>
      )}
      <Icon
        tokens={props.voteUp ? thumbsUpTokens : thumbsDownTokens}
        color={props.voteUp ? "success" : "error"}
        className="chat-messages__feedback-icon"
      />
    </Row>
  </Row>
);

export default UserFeedback;
